export default __webpack_public_path__ + "assets/logo.45172944.png";